// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__39R2s","calendarButtons":"ClockData_calendarButtons__2TTb4"};